<template>
  <div
    class="form-group input-date"
    :class="{ 'form-error': error, 'with-sub-label': subLabel != null }"
  >
    <label>{{ label }}</label>
    <div v-if="subLabel" class="sub-label">
      <small>{{ subLabel }}</small>
    </div>
    <slot />
    <p class="error-message" v-if="error">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "input-date",
  inheritAttrs: false,
  props: {
    label: {
      default: "Label",
      type: String,
    },
    subLabel: {
      default: null,
      type: String,
    },
    error: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: "Invalid input",
      type: String,
    },
  },
};
</script>
